(function () {
  const storageKey = 'tokyo-plus-wishlist';

  function readWishlist() {
    try {
      const stored = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      if (!Array.isArray(stored)) return [];
      return stored.map((item) => (typeof item === 'string' ? { id: item } : item)).filter((item) => item && item.id);
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(items) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(items));
    } catch (error) {
      return;
    }
  }

  function updateProductButton(button, isSaved) {
    const label = isSaved ? button.dataset.removeLabel : button.dataset.addLabel;
    button.setAttribute('aria-pressed', String(isSaved));
    button.setAttribute('aria-label', label);
    button.querySelector('[data-wishlist-label]').textContent = label;
  }

  function renderWishlistPopover() {
    const popover = document.querySelector('[data-wishlist-popover]');
    const count = document.querySelector('[data-wishlist-count]');
    const list = document.querySelector('[data-wishlist-list]');
    const empty = document.querySelector('[data-wishlist-empty]');
    if (!popover || !count || !list || !empty) return;

    const wishlist = readWishlist();
    count.textContent = wishlist.length;
    count.hidden = wishlist.length === 0;
    list.innerHTML = '';
    empty.hidden = wishlist.length > 0;

    wishlist.forEach((item) => {
      if (!item.url || !item.title) return;
      const listItem = document.createElement('li');
      listItem.className = 'wishlist-popover__item';
      const link = document.createElement('a');
      link.className = 'wishlist-popover__link';
      link.href = item.url;

      if (item.image) {
        const image = document.createElement('img');
        image.className = 'wishlist-popover__image';
        image.src = item.image;
        image.alt = '';
        image.loading = 'lazy';
        link.appendChild(image);
      }

      const title = document.createElement('span');
      title.className = 'wishlist-popover__name';
      title.textContent = item.title;
      link.appendChild(title);
      listItem.appendChild(link);
      list.appendChild(listItem);
    });
  }

  function syncProductButtons() {
    const wishlist = readWishlist();
    document.querySelectorAll('[data-wishlist-button]').forEach((button) => {
      updateProductButton(button, wishlist.some((item) => item.id === button.dataset.productId));
    });
    renderWishlistPopover();
  }

  function toggleWishlist(event) {
    const button = event.currentTarget;
    const wishlist = readWishlist();
    const index = wishlist.findIndex((item) => item.id === button.dataset.productId);
    const isSaved = index === -1;

    if (isSaved) {
      wishlist.push({
        id: button.dataset.productId,
        title: button.dataset.productName,
        url: button.dataset.productUrl,
        image: button.dataset.productImage
      });
    } else {
      wishlist.splice(index, 1);
    }

    writeWishlist(wishlist);
    updateProductButton(button, isSaved);
    renderWishlistPopover();
  }

  function setPopoverOpen(isOpen) {
    const popover = document.querySelector('[data-wishlist-popover]');
    const toggle = document.querySelector('[data-wishlist-toggle]');
    if (!popover || !toggle) return;
    popover.hidden = !isOpen;
    toggle.setAttribute('aria-expanded', String(isOpen));
  }

  function initWishlist() {
    document.querySelectorAll('[data-wishlist-button]').forEach((button) => {
      if (button.dataset.wishlistInitialized) return;
      button.dataset.wishlistInitialized = 'true';
      button.addEventListener('click', toggleWishlist);
    });

    const toggle = document.querySelector('[data-wishlist-toggle]');
    const close = document.querySelector('[data-wishlist-close]');
    if (toggle && !toggle.dataset.wishlistInitialized) {
      toggle.dataset.wishlistInitialized = 'true';
      toggle.addEventListener('click', () => {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        setPopoverOpen(!isOpen);
      });
    }
    if (close && !close.dataset.wishlistInitialized) {
      close.dataset.wishlistInitialized = 'true';
      close.addEventListener('click', () => setPopoverOpen(false));
    }

    syncProductButtons();
  }

  document.addEventListener('click', (event) => {
    const wrap = document.querySelector('.header-wishlist-wrap');
    if (wrap && !wrap.contains(event.target)) setPopoverOpen(false);
  });
  document.addEventListener('DOMContentLoaded', initWishlist);
  document.addEventListener('shopify:section:load', initWishlist);
})();
